import React, { useEffect, useRef } from 'react';

// ✅ Добавили проп exchange (по умолчанию 'BINANCE')
interface TradingViewChartProps {
  symbol: string;
  exchange?: string; 
}

export const TradingViewChart: React.FC<TradingViewChartProps> = ({ symbol, exchange = 'BINANCE' }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let isMounted = true;
    let timeoutId: NodeJS.Timeout;

    const renderWidget = () => {
      if (!containerRef.current || !isMounted) return;

      containerRef.current.innerHTML = '';
      const script = document.createElement("script");
      script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
      script.type = "text/javascript";
      script.async = true;
      
      // 1. Очистка символа (BTC/USDT -> BTCUSDT, удаляем суффиксы :USDT)
      let cleanSymbol = symbol.replace('/', '').split(':')[0]; 
      
      // 2. Нормализация названия биржи
      let tvExchange = exchange.toUpperCase();
      if (tvExchange === 'BYBIT') tvExchange = 'BYBIT';
      if (tvExchange === 'BINANCE') tvExchange = 'BINANCE';

      // 3. Формирование тикера для TradingView
      // Для Bybit Futures часто используется формат "BTCUSDT.P", но "BTCUSDT" (Spot) тоже работает для общего графика.
      // Если хотите именно фьючерсный график, можно добавить проверку:
      // const ticker = tvExchange === 'BYBIT' ? `${cleanSymbol}.P` : cleanSymbol;
      
      const formattedSymbol = `${tvExchange}:${cleanSymbol}`;

      script.innerHTML = JSON.stringify({
        "autosize": true,
        "symbol": formattedSymbol,
        "interval": "30",
        "timezone": "Etc/UTC",
        "theme": "dark",
        "style": "1",
        "locale": "ru",
        "enable_publishing": false,
        "allow_symbol_change": true,
        "container_id": `tv_chart_${cleanSymbol}_${tvExchange}`, 
        "support_host": "https://www.tradingview.com"
      });

      if (containerRef.current) {
        containerRef.current.appendChild(script);
      }
    };

    // Небольшая задержка для рендера
    timeoutId = setTimeout(renderWidget, 100);

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, [symbol, exchange]); // ✅ Зависимость от exchange

  return (
    <div className="bg-[#1e293b] border border-slate-800 rounded-[32px] overflow-hidden shadow-2xl" style={{ height: "500px" }}>
      <div 
        id={`tv_chart_${symbol.replace(/[^a-zA-Z0-9]/g, '')}_${exchange}`} 
        ref={containerRef} 
        style={{ height: "100%", width: "100%" }} 
      />
    </div>
  );
};